import { IssueCard } from "./IssueCard";
import type { IssueView } from "@/types/lex";

interface IssueGridProps {
  issues: readonly IssueView[];
  onOpen: (day: number) => void;
  /** Minimum column width in px. Default 220. */
  minCol?: number;
}

/**
 * Borderless grid of issue cards. Borders are painted on the wrapper
 * (top + left) and each cell (right + bottom), with `-1px` margins so
 * adjacent borders collapse cleanly into a single hairline.
 *
 * Each cell uses `display: grid` so the inner button stretches to the row
 * height — without this, cards in the same row align top-only and produce
 * a ragged bottom edge whenever one card's content is taller than its
 * neighbors.
 */
export function IssueGrid({ issues, onOpen, minCol = 220 }: IssueGridProps) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(auto-fill, minmax(${minCol}px, 1fr))`,
        gap: 0,
        borderTop: "var(--border-thin)",
        borderLeft: "var(--border-thin)",
      }}
    >
      {issues.map((issue) => (
        <div
          key={issue.day}
          style={{
            display: "grid",
            borderRight: "var(--border-thin)",
            borderBottom: "var(--border-thin)",
            marginRight: -1,
            marginBottom: -1,
          }}
        >
          <IssueCard issue={issue} flat onOpen={onOpen} />
        </div>
      ))}
    </div>
  );
}
